export default {
  station_comment: {
    name: '评论管理',
    // 属性（一般与对象内容匹配）
    prop: {
      ev_charging_station: '充电站',
      stars: '评分',
      tag: '标签',
      user: '点评用户',
      content: '内容',
      status: '状态',
      images: '点评图片',
      created_at: '点评时间',
      comment: '点评',
      related_order: '点评的订单',
      reply: '回复'
    },
    // 列表标签
    list_tabs: {
      all: '全部'
    },
    labels: {
      comment_reply: '评论回复',
      select_user: '回复用户',
      reply_content: '回复内容'
    },
    // 标题
    title: {
      admin_reply: '管理员回复',
      pass_comment: '通过点评',
      rejected_comment: '屏蔽点评'
    },
    // Enum的属性
    statuses: {
      pending: '待审核',
      passed: '已审核',
      rejected: '已屏蔽'
    },

    stars: { 1: '1星', 2: '2星', 3: '3星', 4: '4星', 5: '5星' },

    // 占位提示
    placeholder: {
      search_keyword: '点评内容',
      select_stars: '1~5星',
      select_tag: '请选择标签',
      input_content: '请输入少于200字的字符'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      stars: '评分',
      tag: '点评标签'
    },
    tips: {
      pass_station_comment: '审核通过，内容将保持在APP显示',
      block_station_comment: '屏蔽后，APP将不显示该点评',
      no_content: '此用户暂未填写评论',
      app_display_logic: 'APP仅显示待审核 和 已审核的记录'
    },
    btn: {
      reply: '回复',
      pass: '通过',
      block: '屏蔽',
      all_pass: '一键通过',
      all_block: '一键屏蔽',
      pending_reply: '回复审核'
    }
  }
}
